import React, { useEffect } from 'react'
import CambioCerealValidoView from '../components/CambioCerealValidoView'
import { connect } from 'react-redux'
import { obtenerCambioCerealValido } from '../actions'

function CambioCerealValido (props) {
  const { obtenerCambioCerealValido } = props

  useEffect(() => {
    obtenerCambioCerealValido()
  }, [obtenerCambioCerealValido])

  return (
    <>
      <CambioCerealValidoView />
    </>
  )
}

const mapActionsToProps = {
  obtenerCambioCerealValido
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(CambioCerealValido)
